import { all } from "redux-saga/effects";
import cccSagas from "./CCC/CCC/sagas.js";
import prescriptionsSagas from "./Prescriptions/state/Prescriptions/state/sagas.js";
import profileSagas from "./Profile/Profile/sagas.js";
import unlinkOrderSagas from "./Unlink/Unlink/sagas.js";
function* sagas() {
  yield all([...cccSagas, ...prescriptionsSagas, ...profileSagas, ...unlinkOrderSagas]);
}
export {
  sagas as default
};
//# sourceMappingURL=sagas.js.map
